import React from 'react';
import { action } from 'mobx';
import { inject, observer } from 'mobx-react';
import { Drawer, DrawerContent } from '@rmwc/drawer';
import {
  List,
  ListDivider,
  ListGroup,
  SimpleListItem,
  CollapsibleList,
} from '@rmwc/list';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import MobileSignInButtons from '../components/MobileSignInButtons';
import { areaGuidesPath } from '../../api/paths/cms';

@inject('headerState')
@observer
class DrawerMenu extends React.PureComponent {
  render() {
    const { drawerOpen, hideLeadLinks } = this.props.headerState;

    return (
      <Drawer
        modal
        open={drawerOpen}
        onClose={this.handleDrawerClose}
        className="sticky-header-drawer"
      >
        <DrawerContent className="mobile-nav-drawer">
          <List>
            <CollapsibleList
              handle={
                <SimpleListItem
                  text="Reviews"
                  metaIcon={<FontAwesomeIcon icon={['far', 'chevron-right']} />}
                />
              }
            >
              <SimpleListItem
                tag="a"
                className="no-wrap"
                href="/members/sign_up/neighborhood?utm_source=pcsgrades&utm_medium=website&utm_content=nav_neighborhood"
                text="Off-Base Neighborhoods"
              />

              <SimpleListItem
                tag="a"
                className="no-wrap"
                href="/members/sign_up/on_base_housing?utm_source=pcsgrades&utm_medium=website&utm_content=nav_on_base_housing"
                text="On Base Housing"
              />

              <SimpleListItem
                tag="a"
                className="no-wrap"
                href="/members/sign_up/apartment?utm_source=pcsgrades&utm_medium=website&utm_content=nav_apartment"
                text="Apartments"
              />

              <SimpleListItem
                tag="a"
                className="no-wrap"
                href="/members/sign_up/moving_company?utm_source=pcsgrades&utm_medium=website&utm_content=nav_moving_company"
                text="Moving Companies"
              />

              <SimpleListItem
                tag="a"
                className="no-wrap"
                href="/members/sign_up/realtor?utm_source=pcsgrades&utm_medium=website&utm_content=nav_realtor"
                text="Real Estate Agents"
              />

              <SimpleListItem
                tag="a"
                className="no-wrap"
                href="/members/sign_up/lender?utm_source=pcsgrades&utm_medium=website&utm_content=nav_lender"
                text="Mortgage Lenders"
              />
            </CollapsibleList>

            <ListDivider tag="hr" />

            <CollapsibleList
              handle={
                <SimpleListItem
                  text="Moving Resources"
                  metaIcon={<FontAwesomeIcon icon={['far', 'chevron-right']} />}
                />
              }
            >
              <SimpleListItem
                tag="a"
                className="no-wrap"
                href="https://www.pcsgrades.com/cms/?utm_source=pcsgrades&utm_medium=website&utm_content=nav-moving-resources"
                text="Blog"
              />

              <SimpleListItem
                tag="a"
                className="no-wrap"
                href="/bah-calculator?utm_source=pcsgrades&utm_medium=website&utm_content=nav-bah-calc"
                text="BAH Calculator"
              />

              <SimpleListItem
                tag="a"
                href={`${areaGuidesPath}?utm_source=pcsgrades&utm_medium=website&utm_content=nav-area-guides`}
                text="Area Guides"
              />

              <SimpleListItem
                tag="a"
                href="/lost-during-my-pcs?utm_source=pcsgrades&utm_medium=website&utm_content=nav-lost-during-my-pcs"
                text="Lost During My PCS"
              />
            </CollapsibleList>

            <ListDivider tag="hr" />

            {!hideLeadLinks && (
              <>
                <ListGroup>
                  <SimpleListItem
                    tag="a"
                    href="/home-loans?utm_source=pcsgrades&utm_medium=website&utm_content=nav-connect-with-lender"
                    className="home-menu-link fs-sm mx-4"
                    text="Find a Lender"
                  />

                  <SimpleListItem
                    tag="a"
                    href="/real-estate-rewards?utm_source=pcsgrades&utm_medium=website&utm_content=nav-find-an-agent"
                    className="home-menu-link find-an-agent-link fs-sm mx-4"
                    text="Find a REALTOR&reg;"
                  />
                </ListGroup>
                <ListDivider tag="hr" />
              </>
            )}

            <CollapsibleList
              handle={
                <SimpleListItem
                  text="About Us"
                  metaIcon={<FontAwesomeIcon icon={['far', 'chevron-right']} />}
                />
              }
            >
              <SimpleListItem
                tag="a"
                className="no-wrap"
                href="/about-us?utm_source=pcsgrades&utm_medium=website&utm_content=nav-about-us"
                text="Our Team"
              />

              <SimpleListItem
                tag="a"
                className="no-wrap"
                href="/contact-us?utm_source=pcsgrades&utm_medium=website&utm_content=nav-contact-us"
                text="Contact Us"
              />

              <SimpleListItem
                tag="a"
                href="/faqs?utm_source=pcsgrades&utm_medium=website&utm_content=nav-faqs"
                text="FAQs"
              />
            </CollapsibleList>
          </List>

          <MobileSignInButtons />
        </DrawerContent>
      </Drawer>
    );
  }

  @action.bound
  handleDrawerClose(_event) {
    this.props.headerState.drawerOpen = false;
  }
}

export default DrawerMenu;
